import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const DomainRouter = () => {
  const history = useHistory();

  useEffect(() => {
    const { hostname } = window.location;

    // Se acessou via testes.cartefacile.com, redireciona para mobile-signin
    if (hostname === 'testes.cartefacile.com') {
      history.replace('/mobile-signin');
    }
    // Se acessou via test.diretiva1.com.br, segue fluxo normal
  }, [history]);

  return null; // Este componente não renderiza nada
};

export default DomainRouter;
